import React, { useEffect, useState } from "react";

import FormAction from "../../../../../../components/common/FormAction";
import MultiSelect from "../../../../../../components/common/MultiSelect";
import TreeMultiSelect from "../../../../../../components/common/TreeSelect";
import { v4 as uuid } from "uuid";

import { glAccounts } from "../../../../../../data/accounting";
import { assignees, vendorTrades } from "../../data";

import { TbCurrencyDollar } from "react-icons/tb";
import { RiCloseCircleLine, RiAddCircleFill } from "react-icons/ri";

import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
} from "antd";
import TextArea from "antd/es/input/TextArea";

import "./NewWorkOrder.css";
import { useSelector } from "react-redux";
import { SelectUser } from "../../../../../../store/usersSlice";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../../../../../firebase";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import toast from "react-hot-toast";

function NewWorkOrder({
  setAddWorkOrder,
  workOrderId,
  property,
  data,
  workOrderNumber,
  setCancelEdit,
}) {
  const [value, setValue] = useState("");
  const [vendorInfo, setVendorInfo] = useState({});
  console.log("datadatadata",data)

  const onCancel = () => {
    if (data?.id) {
      setCancelEdit(false);
    } else {
      setAddWorkOrder(false);
    }
  };

  const onChange = async (value) => {
    setValue(value);
    const vendorRef = doc(
      db,
      "companies",
      userData?.companyName,
      "vendors",
      value
    );

    try {
      const snapShot = await getDoc(vendorRef);

      if (snapShot.exists()) {
        setVendorInfo(snapShot.data());
      } else {
        // Handle the case when the document does not exist
        console.log("Document does not exist");
      }
    } catch (error) {
      // Handle any potential errors
      console.error("Error fetching data:", error);
    }
  };

  const [labors, setLabors] = useState([
    { id: uuid(), maintenanceTech: "", date: "", hours: "", description: "" },
  ]);

  useEffect(() => {
    if (data?.labors?.length > 0) {
      setLabors(data?.labors);
    }
  }, [data]);
  console.log("labors data", labors);

  const addLabor = () => {
    const newLabor = {
      id: uuid(),
      maintenanceTech: "",
      date: "",
      hours: "",
      description: "",
    };
    setLabors([...labors, newLabor]);
  };

  const removeLabor = (laborId) => {
    const updatedLabors = labors.filter((item) => item.id !== laborId);
    setLabors(updatedLabors);
  };

  const [supplies, setSupplies] = useState([
    {
      id: uuid(),
      quantity: "",
      itemType: "",
      account: "",
      salePrice: "",
      total: "",
    },
  ]);

  const addSuplies = () => {
    const newSupply = {
      id: uuid(),
      quantity: "",
      itemType: "",
      account: "",
      salePrice: "",
      total: "",
    };
    setSupplies([...supplies, newSupply]);
  };

  const removeSupplies = (supplyId) => {
    const updatedSupplies = supplies.filter((item) => item.id !== supplyId);
    setSupplies(updatedSupplies);
  };

  const onSupplyChange = (value, name, supplyId) => {
    const updatedSupplies = supplies.map((item) => {
      if (item.id === supplyId) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setSupplies(updatedSupplies);
  };

  const onInputChange = (value, name, supplyId) => {
    const updatedLabors = labors.map((item) => {
      if (item.id === supplyId) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setLabors(updatedLabors);
  };

  const onDateChange = (value, name, supplyId) => {
    const updatedLabors = labors.map((item) => {
      if (item.id === supplyId) {
        return { ...item, [name]: value.format("YYYY-MM-DD") };
      }
      return item;
    });
    setLabors(updatedLabors);
  };

  const [billItems, setBillItems] = useState([
    {
      id: uuid(),
      quantity: "",
      account: "",
      statementDescription: "",
      rate: "",
      total: "",
    },
  ]);

  const addBillItem = () => {
    const newBillItem = {
      id: uuid(),
      quantity: "",
      account: "",
      statementDescription: "",
      rate: "",
      total: "",
    };
    setBillItems([...billItems, newBillItem]);
  };

  const removeBillItem = (itemId) => {
    const updatedBillItems = billItems.filter((item) => item.id !== itemId);
    setBillItems(updatedBillItems);
  };

  const onBillItemChange = (value, name, itemId) => {
    const updatedBillItems = billItems.map((item) => {
      if (item.id === itemId) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setBillItems(updatedBillItems);
  };

  const [vendorsData, setVendorsData] = useState([]);
  const [users, setUsers] = useState([]);

  const userData = useSelector(SelectUser);
  console.log("userDataKKKKK", userData);

  const fetchVendors = async () => {
    try {
      const vendorRef = collection(
        db,
        "companies",
        userData?.companyName,
        "vendors"
      );
      const userRef = collection(
        db,
        "companies",
        userData.companyName,
        "users"
      );
      const snapShot = await getDocs(vendorRef);
      const userSnapShot = await getDocs(userRef);
      const fetchedData = snapShot.docs.map((doc) => ({
        id: doc.id,
        value: doc.id,
        label:
          doc.data().vendorInfo.firstName +
          " " +
          doc.data().vendorInfo.lastName,
        ...doc.data(),
      }));
      const fetchedUsers = userSnapShot.docs.map((doc) => ({
        id: doc.id,
        value: doc.id,
        label: doc.data().profile.firstName + " " + doc.data().profile.lastName,
        ...doc.data(),
      }));
      console.log("vendors data", fetchedData);
      console.log("hehehehehe");
      setVendorsData(fetchedData);
      setUsers(fetchedUsers);
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    fetchVendors();
    console.log("***************");
  }, []);

  console.log("vendorsData88888888", vendorsData);
  const [isLoading, setIsLoading] = useState(false);

  const onFormSubmit = async (values) => {
    setIsLoading(true)
    console.log("Values*********", values);
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });
    const newLabors = labors.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const newSupplies = supplies.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const newBillItems = billItems.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    console.log("newuuu", newSupplies);
    console.log("billitems", newBillItems);
    console.log("userData.companyName", userData.companyName);
    console.log("workOrderId.workOrderId", workOrderId);


    const requestRef = doc(
      db,
      "companies",
      userData.companyName,
      "workOrders",
      workOrderId
    );
  
    try {
      const docSnapshot = await getDoc(requestRef);
      let existingArray = [];
  
      if (docSnapshot.exists()) {
        const existingData = docSnapshot.data();
        existingArray = existingData.relatedWorkOrders || [];
      }
  
      const existingIndex = existingArray.findIndex((order) => order.id === data?.id);
  
      if (existingIndex !== -1) {
        // Update the existing work order
        existingArray[existingIndex] = {
          id: data?.id,
          ownerApproved: values.ownerApproved,
          jobDescription: values.jobDiscription,
          vendorInstructions: values.vendorInstructions,
          vendorTrade: values.vendorTrade,
          assignTo: values.assignTo,
          labors: newLabors.length > 0 ? newLabors : [],
          supplies: newSupplies.length > 0 ? newSupplies : [],
          billItems: newBillItems.length > 0 ? newBillItems : [],
          purchaseOrderNumber: values.purchaseOrderNumber,
          invoice: values.invoice,
          residentCreatingBill: values.residentCreatingBill,
          vendorId: values.vendorId,
        };
      } else {
        // Add a new work order
        existingArray.push({
          id: uuid(), // Make sure to provide a unique ID
          ownerApproved: values.ownerApproved,
          jobDescription: values.jobDiscription,
          vendorInstructions: values.vendorInstructions,
          vendorTrade: values.vendorTrade,
          assignTo: values.assignTo,
          labors: newLabors.length > 0 ? newLabors : [],
          supplies: newSupplies.length > 0 ? newSupplies : [],
          billItems: newBillItems.length > 0 ? newBillItems : [],
          purchaseOrderNumber: values.purchaseOrderNumber,
          invoice: values.invoice,
          residentCreatingBill: values.residentCreatingBill,
          vendorId: values.vendorId,
          emailVendorLink: values.emailVendorLink,
          textVendorLink: values.textVendorLink,
          requestVendorToConfirmReciept: values.requestVendorToConfirmReciept,
          adjusmentPercent: values.adjusmentPercent,
          adjustmentType: values.adjustmentType,
        });
      }
  
      const updateRequest = {
        relatedWorkOrders: existingArray,
      };
      console.log("updateRequestupdateRequestupdateRequest",updateRequest)
      await updateDoc(requestRef, updateRequest);
      console.log("Updated successfully");
      toast.success("updated");
      setAddWorkOrder(false);
    setIsLoading(false)

      if(data?.id){
        setCancelEdit(false);
      }
    } catch (err) {
      console.error("Error", err);
    setIsLoading(false)

    }
  };

  const onFinishFailed = (err) => {
    console.log("Form submission failed", err);
    setIsLoading(false)

  };

  console.log("vendor info against selection", vendorInfo);

  const initialValues = {
    ownerApproved: data?.ownerApproved ? data?.ownerApproved : "",
    jobDiscription: data?.jobDescription ? data?.jobDescription : "",
    vendorInstructions: data?.vendorInstructions
      ? data?.vendorInstructions
      : "",
    vendorTrade: data?.vendorTrade ? data?.vendorTrade : "",
    vendorId: data?.vendorId ? data?.vendorId : "",
    emailVendorLink: data?.emailVendorLink ? data?.emailVendorLink : "",
    textVendorLink: data?.textVendorLink ? data?.textVendorLink : "",
    requestVendorToConfirmReciept: data?.requestVendorToConfirmReciept
      ? data?.requestVendorToConfirmReciept
      : "",
    purchaseOrderNumber: data?.purchaseOrderNumber
      ? data?.purchaseOrderNumber
      : "",
    residentCreatingBill: data?.residentCreatingBill
      ? data?.residentCreatingBill
      : "",
    invoice: data?.invoice ? data?.invoice : "",
    adjusmentPercent: data?.adjusmentPercent ? data?.adjusmentPercent : "",
    adjustmentType: data?.adjustmentType ? data?.adjustmentType : "",
    assignTo: data?.assignTo ? data?.assignTo : "",
  };

  return (
    <Row className="new-work-order">
      <Col span={24}>
        <Row gutter={[0, 8]}>
          <Col span={24}>
            <Row className="work-order-header">
              <Col>
                {data?.id ? (
                  <span>Edit Work Order</span>
                ) : (
                  <span>New Work Order</span>
                )}
              </Col>
            </Row>
            <Form
              layout="vertical"
              onFinish={onFormSubmit}
              onFinishFailed={onFinishFailed}
              initialValues={data && initialValues}
            >
              <Row className="work-order-content" gutter={[0, 16]}>
                <Col span={24}>
                  <Row justify="end">
                    <Col>
                      <Form.Item name="ownerApproved" valuePropName="checked">
                        <Checkbox>Owner approved</Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                <Col span={24} className="col-container">
                  <p className="title">Job Description</p>
                  <Form.Item name="jobDiscription">
                    <TextArea />
                  </Form.Item>
                </Col>
                <Col span={24} className="col-container">
                  <p className="title">Vendor Instructions</p>
                  <Form.Item name="vendorInstructions">
                    <TextArea />
                  </Form.Item>
                </Col>
                <Col span={24} className="col-container">
                  <p className="title">Vendor Trade</p>
                  <Form.Item name="vendorTrade">
                    <Select options={vendorTrades} defaultValue="cleaning" />
                  </Form.Item>
                </Col>
                <Col span={24} className="col-container">
                  <p className="title">Vendor Suggestions</p>
                  <p style={{ textAlign: "center" }}>
                    Assign a vendor trade to generate suggestions.
                  </p>
                </Col>
                <Col span={24} className="col-container">
                  <p className="title">Vendor</p>
                  <Form.Item name="vendorId">
                    <Select
                      options={vendorsData}
                      allowClear
                      showSearch
                      onChange={onChange}
                      value={value}
                    />
                  </Form.Item>
                  {value !== "" ? (
                    <>
                      <Form.Item name="emailVendorLink" valuePropName="checked">
                        <Checkbox>
                          Email vendor a secure link to view this work order
                        </Checkbox>
                      </Form.Item>
                      <Form.Item name="textVendorLink" valuePropName="checked">
                        <Checkbox>
                          Text vendor a secure link to view this work order
                        </Checkbox>
                      </Form.Item>
                      <Form.Item
                        name="requestVendorToConfirmReciept"
                        valuePropName="checked"
                      >
                        <Checkbox>
                          Request vendor to confirm receipt of work order
                        </Checkbox>
                      </Form.Item>
                    </>
                  ) : null}
                  <Form.Item label="Assign To" name="assignTo">
                    <Select
                      mode="multiple"
                      options={users}
                      placeholder="Selec..."
                    />
                  </Form.Item>
                  {value !== "" ? (
                    <Row gutter={[24, 0]}>
                      <Col span={12} className="vendor-details">
                        <Row gutter={[0, 8]}>
                          <Col span={24}>
                            <p className="title">VENDOR</p>
                            {/* <span className="onclick-text">{data?.vendor}</span> */}
                          </Col>
                          <Col span={24}>
                            <p>
                              <strong>Mobile:</strong>{" "}
                              <span className="onclick-text">
                                {vendorInfo?.contact?.phoneNumbers.length > 0
                                  ? vendorInfo?.contact?.phoneNumbers[0]
                                      .phoneNumber
                                  : "--"}
                              </span>
                            </p>
                          </Col>
                          <Col span={24}>
                            <p>
                              <strong>Email:</strong>{" "}
                              <span className="onclick-text">
                                {vendorInfo?.contact?.emails.length > 0
                                  ? vendorInfo?.contact?.emails[0].email
                                  : "--"}
                              </span>
                            </p>
                          </Col>
                          <Col span={24}>
                            <p>
                              {vendorInfo?.contact?.addresses.length > 0
                                ? vendorInfo?.contact?.addresses[0].addressLine1
                                : "--"}
                            </p>
                          </Col>
                          <Col span={24}>
                            <p
                              className="onclick-text"
                              onClick={() => setValue("")}
                            >
                              {" "}
                              Remove{" "}
                            </p>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={12}>
                        <Form.Item>
                          <p className="title">Work Order Adjustments</p>
                        </Form.Item>
                        <Form.Item
                          label="Adjustment Percent"
                          name="adjusmentPercent"
                          required
                        >
                          <Input placeholder="Percent" />
                        </Form.Item>
                        <Form.Item
                          label="Adjustment Type"
                          name="adjustmentType"
                        >
                          <Select
                            options={[
                              { value: "Discount" },
                              { value: "Markup" },
                            ]}
                            defaultValue="Discount"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  ) : null}
                </Col>
                <Col span={24} className="col-container">
                  <p className="title">Property</p>
                  <p>
                    {property?.propertyNameAddress
                      ? property?.propertyNameAddress?.propertyName
                      : "--"}
                  </p>
                </Col>
                <Col span={24} className="col-container">
                  <p className="title">Labor</p>
                  <Row>
                    <Col className="header-col" span={10}>
                      <span>Maintenance Tech</span>
                    </Col>
                    <Col className="header-col" span={3}>
                      <span>Date</span>
                    </Col>
                    <Col className="header-col" span={3}>
                      <span>Hours</span>
                    </Col>
                    <Col className="header-col" span={7}>
                      <span>Description</span>
                    </Col>
                  </Row>
                  {labors.map((item) => {
                    return (
                      <Row align="middle" gutter={[8, 0]} key={item.id}>
                        <Col span={10}>
                          <Form.Item>
                            <Select
                              options={[{ value: "1" }, { value: "2" }]}
                              allowClear
                              showSearch
                              onChange={(value) =>
                                onInputChange(value, "maintenanceTech", item.id)
                              }
                              value={item.maintenanceTech}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={3}>
                          <Form.Item>
                            <DatePicker
                              onChange={(value) =>
                                onDateChange(value, "date", item.id)
                              }
                              value={item.date ? dayjs(item.date, "YYYY-MM-DD") : ""}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={3}>
                          <Form.Item>
                            <Input
                              onChange={(e) =>
                                onInputChange(e.target.value, "hours", item.id)
                              }
                              value={item.hours}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={7}>
                          <Form.Item>
                            <Input
                              onChange={(e) =>
                                onInputChange(
                                  e.target.value,
                                  "description",
                                  item.id
                                )
                              }
                              value={item.description}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={1}>
                          <Form.Item>
                            <RiCloseCircleLine
                              className="onclick-red-text"
                              size={22}
                              onClick={() => removeLabor(item.id)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  })}
                  <Row>
                    <Col span={24}>
                      <button className="add-icon-btn" onClick={addLabor}>
                        <RiAddCircleFill />
                        <span>Add Another Line</span>
                      </button>
                    </Col>
                  </Row>
                </Col>
                <Col span={24} className="col-container">
                  <p className="title">Withheld Amount from Owner</p>
                  <p>--</p>
                </Col>
                <Col span={24} className="col-container">
                  <p className="title">Purchase Order #</p>
                  <Form.Item name="purchaseOrderNumber">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24} className="col-container">
                  <p className="title">Parts And Supplies</p>
                  <Row>
                    <Col span={3}>
                      <span>Qty</span>
                    </Col>
                    <Col span={6}>
                      <span>Item Type</span>
                    </Col>
                    <Col span={6}>
                      <span>Account</span>
                    </Col>
                    <Col span={4}>
                      <span>Sale Price</span>
                    </Col>
                    <Col span={4}>
                      <span>Total</span>
                    </Col>
                  </Row>
                  {supplies.map((item) => {
                    return (
                      <Row gutter={[8, 0]} key={item.id}>
                        <Col span={3}>
                          <Form.Item>
                            <Input
                              placeholder="Quantity"
                              onChange={(e) =>
                                onSupplyChange(
                                  e.target.value,
                                  "quantity",
                                  item.id
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item>
                            <Select
                              options={[
                                { value: "type 1" },
                                { value: "type 2" },
                              ]}
                              placeholder="Start typing to search"
                              showSearch
                              allowClear
                              onChange={(value) =>
                                onSupplyChange(value, "itemType", item.id)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item>
                            <TreeMultiSelect
                              options={glAccounts}
                              placeholder="Select"
                              onChange={(value) =>
                                onSupplyChange(value, "account", item.id)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item>
                            <InputNumber
                              addonBefore={<TbCurrencyDollar size={16} />}
                              onChange={(value) =>
                                onSupplyChange(value, "salePrice", item.id)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item>
                            <InputNumber
                              addonBefore={<TbCurrencyDollar size={16} />}
                              onChange={(value) =>
                                onSupplyChange(value, "total", item.id)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={1}>
                          <Form.Item>
                            <RiCloseCircleLine
                              size={18}
                              className="onclick-red-text"
                              onClick={() => removeSupplies(item.id)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  })}
                  <Row>
                    <Col span={24}>
                      <button className="add-icon-btn" onClick={addSuplies}>
                        <RiAddCircleFill />
                        <span>Add Another Line</span>
                      </button>
                    </Col>
                  </Row>
                </Col>
                <Col span={24} className="col-container">
                  <p className="title">Billable Items</p>
                  <Row>
                    <Col className="header-col" span={4}>
                      <span>Qty</span>
                    </Col>
                    <Col className="header-col" span={6}>
                      <span>Account</span>
                    </Col>
                    <Col className="header-col" span={6}>
                      <span>Statement Description</span>
                    </Col>
                    <Col className="header-col" span={4}>
                      <span>Rate</span>
                    </Col>
                    <Col className="header-col" span={3}>
                      <span>Total</span>
                    </Col>
                  </Row>
                  {billItems.map((item) => {
                    return (
                      <Row gutter={[8, 0]} key={item.id}>
                        <Col span={4}>
                          <Form.Item>
                            <Input
                              placeholder="Quantity"
                              onChange={(e) =>
                                onBillItemChange(
                                  e.target.value,
                                  "quantity",
                                  item.id
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item>
                            <TreeMultiSelect
                              options={glAccounts}
                              placeholder="Select..."
                              onChange={(value) =>
                                onBillItemChange(value, "account", item.id)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item>
                            <Input
                              placeholder="Statement Description"
                              onChange={(e) =>
                                onBillItemChange(
                                  e.target.value,
                                  "statementDescription",
                                  item.id
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item>
                            <Input
                              onChange={(e) =>
                                onBillItemChange(
                                  e.target.value,
                                  "rate",
                                  item.id
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={3}>
                          <Form.Item>
                            <InputNumber
                              addonBefore={<TbCurrencyDollar size={16} />}
                              onChange={(value) =>
                                onBillItemChange(value, "total", item.id)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={1}>
                          <Form.Item>
                            <RiCloseCircleLine
                              size={22}
                              className="onclick-red-text"
                              onClick={() => removeBillItem(item.id)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  })}
                  <Row>
                    <Col span={24}>
                      <button className="add-icon-btn" onClick={addBillItem}>
                        <RiAddCircleFill />
                        <span>Add Another Line</span>
                      </button>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Form.Item label="Invoice" name="invoice">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="residentCreatingBill"
                    valuePropName="checked"
                  >
                    <Checkbox>Charge resident when creating bill</Checkbox>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <FormAction submit="submit" cancel={onCancel} loading={isLoading}/>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default NewWorkOrder;
